import axios from 'axios'
import { useSpinner } from '@/stores/spinner'

export const registerAxiosSpinnerInterceptors = () => {
  const spinner = useSpinner()

  axios.interceptors.request.use((config) => {
    if (!config.__disableSpinner__) {
      spinner.start()
    }

    return config
  })

  axios.interceptors.response.use(
    (response) => {
      spinner.stop()
      return response
    },
    (error) => {
      spinner.stop()
      return Promise.reject(error)
    },
  )
}
